  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of CardPreview.
 */ export const renderCardPreview_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ _jsxs(state.root, {
        children: [
            state.root.children,
            state.logo && /*#__PURE__*/ _jsx(state.logo, {})
        ]
    });
};
